<template>
  <div class="page">
    <smart-block
        background-color="#83c815"
        link="/explore-local/community/emergency-numbers"
        heading="Emergency Numbers"></smart-block>
    <smart-block
        background-color="#83c815"
        link="https://www.facebook.com/OMYG18"
        heading="Youth Space"></smart-block>
    <smart-block
        background-color="#83c815"
        link="https://www.facebook.com/othccnz"
        heading="Community Centre"></smart-block>
    <smart-block
        background-color="#83c815"
        link=""
        heading="Support Local Grape Vine"></smart-block>
    <smart-block
        background-color="#83c815"
        link="https://www.facebook.com/otahuhulib"
        heading="Toia Library"></smart-block>
    <smart-block
        background-color="#17458f"
        is-icon-only="is-icon-only"
        background-image="none"
        link="https://www.rotarydistrict9920.org/clubInfo/otahuhu-(inc)"
        icon="https://ucarecdn.com/ccc7d6aa-bca4-4237-b999-d7706f8af427/"></smart-block>
  </div>
</template>

<script>
import SmartBlock from "../../components/SmartBlock.vue";
export default {
  components: {
    SmartBlock,
  },
  data() {
    return {

    }
  }
}
</script>
